import { Header, Footer, AboutUsLanding, ContactIntro, ContactForm} from '../../components';
import { meltenEffect } from '../../utils/Effects';


function scrollEffects() {
  meltenEffect('contact-intro-text');
  meltenEffect('contact-form-wrapper');
  meltenEffect('contact-datas');
}

window.addEventListener("scroll", scrollEffects);
window.addEventListener("touchmove", scrollEffects);


function AboutUs() {

  return (
    <>
      <Header title='aboutus'/>
      <main className="flex flex-col text-primary">
        <AboutUsLanding />
        <ContactIntro />
        <ContactForm />
        <Footer />
      </main>
    </>
  );
}

export default AboutUs;